import { store } from '../store'
import {  NavigationGuardNext } from 'vue-router'

/**
 * QboGuard
 * 
 * Checks if the tenant has an active QuickBooks Online connection.
 * If the connection test is true, continue.
 * If the connection test is false, then send the user to the qbo connection page.
 */
const qboGuard = (to, from, next: NavigationGuardNext) => {

    //  If the connection already exists, pass and continue
    if (store.getters.qboConnection) {
        store.getters.appDebug && console.log('GUARD: qbo-guard pass... (already true)')
        return next()
    }

    //  Test the qbo connection
    const qboConnection = store.dispatch('qboConnectionTest').then(() => {
        //  If the connect is true. pass...
        if (qboConnection) {
            store.getters.appDebug && console.log('GUARD: qbo-guard pass...(true)')
            return next()
        }

        //  Else, fail...
        store.getters.appDebug && console.log('GUARD: qbo-guard stop.')

        //  Continue to route
        return next()

    })
}

export default qboGuard
